import * as actions from "../../../actions/budget/report";

const initialState = {
  loading: false,
  items: []
};

const reducer = function(state = initialState, { type, payload }) {
  switch (type) {
    case actions.GET_BUDGETS: {
      return {
        ...state,
        loading: true
      };
    }
    case actions.GET_BUDGETS_FAILED: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.GET_BUDGETS_SUCCESS: {
      return {
        ...state,
        items: payload ? payload : [],
        loading: false
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
